import { capturedGet, capturedPost, capturedPut } from '../../http';

const state = {};
const getters = {};
const mutations = {};
const actions = {
  async getTracks (context, { platform, params }) {
    return await capturedGet(`/${platform}/track`, params)
  },
  async addTrack (context, { platform, params }) {
    return await capturedPost(`/${platform}/track`, params)
  },
  async updateTrack (context, { platform, id, params }) {
    return await capturedPut(`/${platform}/track/${id}`, params)
  },
  async getTrack (context, { platform, id }) {
    return await capturedGet(`/${platform}/track/${id}`)
  },
  async getEventTypes (context, { platform }) {
    return await capturedGet(`/${platform}/track/eventType`)
  },
  async openTrack (context, { platform, id }) {
    return await capturedPost(`/${platform}/track/open/${id}`)
  },
  async stopTrack (context, { platform, id }) {
    return await capturedPost(`/${platform}/track/stop/${id}`)
  },
  async removeTrack (context, { platform, id }) {
    return await capturedPost(`/${platform}/track/delete/${id}`)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
};
